import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.showLink}}\n  <div class=\"back-to-courses\">\n    <LinkTo @route=\"courses\">\n      {{t \"general.backToCourses\"}}\n    </LinkTo>\n  </div>\n{{/if}}\n", {
  moduleName: "ilios-common/components/course/back-to-courses.hbs"
});